export default {"src":"/_next/static/media/paper-plane.68dc76dc.svg","height":20,"width":21,"blurWidth":0,"blurHeight":0};